// import cardGameImg from "../images/projImg1.jfif";
import ProjText from "../images/ProjText.jfif";
import ProjNews from "../images/ProjNews.jpg";
// import ProjCar from "../images/ProjCar.avif";
import netflixProj from "../images/netflixProj.png";
import postmasterProj from "../images/postmasterProj.png";
import amazonProj from "../images/amazonProj.jpg";

const projectCardData = [
  {
    id: "1",
    img: netflixProj,
    top: "Netflix UI",
    bottom: "ReactJs / Sass / Javascript",
    btnLink: "https://priyansh1626.github.io/Netflix/",
    btn: "Visit",
  },
  {
    id: "2",
    img: postmasterProj,
    top: "Post Master",
    bottom: "Html / Css / Javascript",
    btnLink: "https://postmaster-priyansh.netlify.app/",
    btn: "Visit",
  },
  {
    id: "3",
    img: amazonProj,
    top: "E-Commerce",
    bottom: "ReactJs / MongoDB / Javascript / Sass",
    btnLink: "https://github.com/Priyansh1626?tab=repositories",
    btn: "visit",
  },
  {
    id: "4",
    img: ProjNews,
    top: "NewsHunt",
    bottom: "ReactJS / Sass / Javascript",
    btnLink: "https://github.com/Priyansh1626/NewsHunt",
    btn: "Clone",
  },
  // {
  //   id: "5",
  //   img: ProjCar,
  //   top: "Car Game",
  //   bottom: "ReactJs / Sass / Javascript",
  //   btnLink: "/",
  //   btn: "Play",
  // },
  {
    id: "6",
    img: ProjText,
    top: "TextUtility",
    bottom: "Html / Css / Javascript",
    btnLink: "https://github.com/Priyansh1626/TextConverter",
    btn: "Visit",
  },
];

export default projectCardData;
